var React = require('react');

function IconElectricityInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M17 28.9132L32 42.3571L47 28.9132L44.9737 26.9535L32.9927 37.6703L33.2647 36.4369V7H30.6537V36.3547L30.8849 37.7114L19.0263 26.9535L17 28.9132Z","fill":"#00B0B9","key":0}),React.createElement("path",{"d":"M34.0568 63.3866L38.3194 52.876H26.933L21.0938 75.6489H29.7358L26.1155 88.2616L22.5536 86.6267L23.6046 97.1956L32.2467 91.0061L28.8015 89.4879L42.3485 69.6929H31.4876","stroke":"#00B0B9","strokeWidth":"2.14286","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

IconElectricityInline.defaultProps = {"width":"64","height":"105","viewBox":"0 0 64 105","fill":"none"};

module.exports = IconElectricityInline;

IconElectricityInline.default = IconElectricityInline;
